import { renderToStaticMarkup } from 'react-dom/server';

import type { TResolvedItemNames } from '@modules/items';

import { getBlockDisplayName } from '../../helpers/blocks.helper';
import { BlockHeader } from '../../tiptap/nodes/block/BlockHeader';
import type { TBlockVersionMode, TDocument, TDraft, TVersion } from '../../types';

type TOptions = {
  doc: TDocument;
  version: TDraft | TVersion | undefined;
  resolvedItemNames: TResolvedItemNames;
  versionId: string;
};

export const makeBlockHeaderRenderer =
  ({ doc, version, resolvedItemNames, versionId }: TOptions) =>
  (attrs: Readonly<Record<string, string>>): string => {
    // No entry is a block the editor draws as "Unknown" in the error styling, not one with no header.
    const blockData = doc.blocksData?.[attrs['data-id'] ?? ''];
    const entry = blockData?.versions[versionId];
    return renderToStaticMarkup(
      <BlockHeader
        name={getBlockDisplayName(
          doc,
          version,
          resolvedItemNames,
          blockData,
          (attrs['data-version-mode'] as TBlockVersionMode) ?? 'AUTO',
          entry
        )}
        href={`/document/${attrs['data-item'] ?? ''}`}
        isQm={Boolean(blockData?.isQm)}
        isError={!entry}
      />
    );
  };
